import { useTu } from "@src/appV2/i18n/useTu";
import { Tab, Tabs } from "@src/appV2/redesign/components/Tabs";

import { CaseStatus } from "../types";

interface MobileCaseStatusTabsProps {
  value: CaseStatus;
  onChange: (value: CaseStatus) => void;
}

/**
 * Active/Closed filter for the mobile cases list, styled like
 * {@link MobileVisitStatusTabs} to keep the HH mobile surfaces consistent.
 */
export function MobileCaseStatusTabs({ value, onChange }: MobileCaseStatusTabsProps) {
  const { tu } = useTu("homeHealth");

  return (
    <Tabs
      variant="invertedPill"
      value={value}
      aria-label={tu("Case status")}
      sx={{
        width: "100%",
        "& .MuiTabs-flexContainer": { display: "flex" },
        "& .MuiTab-root": { flex: 1, minWidth: 0 },
      }}
      onChange={(_, newValue: CaseStatus) => {
        onChange(newValue);
      }}
    >
      <Tab label={tu("Active")} value={CaseStatus.OPEN} />
      <Tab label={tu("Closed")} value={CaseStatus.CLOSED} />
    </Tabs>
  );
}
